export class Toggle {
    private $element: JQuery;
    public onChange?: { () };

    constructor() {
        this.$element = $('<div class="toggle"><div class="handle" /></div>');
        this.$element.click((e) => {
            e.preventDefault();
            this.setValue(!this.getValue());

            if (this.onChange !== undefined) this.onChange();
        });
    }

    public getValue(): boolean {
        return this.$element.hasClass("active");
    }

    public setValue(val: boolean): Toggle {
        if (val) this.$element.addClass("active");
        else this.$element.removeClass("active");

        return this;
    }

    public appendTo($element: JQuery): Toggle {
        this.$element.appendTo($element);

        return this;
    }
}
